import { ISOs } from '../form/constants';

export const DEFAULT_BILLING_COUNTRY = ISOs.USA;
